import React from 'react';
import '../../css/Shared/DropDownTable.css';

function DropDownTable(props) {
    return (
        <>
            <table class='DropDownTableRowDiv' onClick={props.onClick} >
                <td class="DropDownTableRowPosition" id={props.id} key={props.key}>
                    {props.children}
                </td>
            </table>
        </>
    );
}
export default DropDownTable;
